import { useState } from 'react';
import { useMarketingData } from '../MarketingContext';
import { StandardStatus } from '../types';

export default function StandardsPage() {
  const { standards, updateStandard } = useMarketingData();
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState<typeof standards[0] | null>(null);

  const complianceColors: Record<string, string> = {
    not_reviewed: 'bg-gray-100 text-gray-600', under_review: 'bg-amber-100 text-amber-700',
    compliant: 'bg-green-100 text-green-700', partially_compliant: 'bg-orange-100 text-orange-700',
    requires_action: 'bg-red-100 text-red-700', not_applicable: 'bg-slate-100 text-slate-500',
  };

  const filtered = standards.filter(s => {
    if (search && !s.name.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  if (selected) {
    return (
      <div className="space-y-4">
        <button onClick={() => setSelected(null)} className="text-sm text-blue-600 hover:underline">← Back to Standards</button>
        <div className="bg-white border border-gray-200 rounded-xl p-6">
          <div className="flex items-start justify-between mb-4">
            <div>
              <h2 className="text-xl font-bold text-gray-900">{selected.name}</h2>
              <div className="text-sm text-gray-500 mt-0.5">{selected.organization} · v{selected.version} · {selected.region}</div>
              <div className="flex gap-2 mt-2">
                <span className={`text-xs px-2 py-0.5 rounded-full ${complianceColors[selected.complianceStatus]}`}>{selected.complianceStatus.replace('_', ' ')}</span>
                <span className="text-xs text-gray-400">Last reviewed: {selected.lastReviewed}</span>
              </div>
            </div>
            <div className="flex gap-1.5">
              {(Object.keys(complianceColors) as StandardStatus[]).map(status => (
                <button key={status} onClick={() => { updateStandard(selected.id, { complianceStatus: status }); setSelected({ ...selected, complianceStatus: status }); }} className={`text-[10px] px-2 py-1 rounded-full ${complianceColors[status]} hover:opacity-80`}>{status.replace('_', ' ')}</button>
              ))}
            </div>
          </div>
          <div className="space-y-4">
            <div><h3 className="text-sm font-semibold text-gray-900 mb-1">Summary</h3><p className="text-sm text-gray-600">{selected.summary}</p></div>
            <div><h3 className="text-sm font-semibold text-gray-900 mb-1">Requirements</h3><p className="text-sm text-gray-600">{selected.requirements}</p></div>
            <div><h3 className="text-sm font-semibold text-gray-900 mb-1">Implementation Checklist</h3><pre className="text-sm text-gray-600 whitespace-pre-wrap bg-gray-50 p-3 rounded-lg">{selected.checklist}</pre></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div><h1 className="text-2xl font-bold text-gray-900">Industry Standards</h1><p className="text-sm text-gray-500">Standards, frameworks, guidelines, and compliance tracking</p></div>
      <div className="bg-white p-3 rounded-xl border border-gray-200">
        <input type="text" value={search} onChange={e => setSearch(e.target.value)} placeholder="Search standards..." className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg" />
      </div>
      <div className="space-y-3">
        {filtered.map(s => (
          <button key={s.id} onClick={() => setSelected(s)} className="w-full bg-white border border-gray-200 rounded-xl p-4 text-left hover:shadow-md transition-shadow">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm font-bold text-gray-900">{s.name}</div>
                <div className="text-xs text-gray-500 mt-0.5">{s.organization} · v{s.version} · {s.industry} · {s.region}</div>
              </div>
              <span className={`text-xs px-2 py-0.5 rounded-full ${complianceColors[s.complianceStatus]}`}>{s.complianceStatus.replace('_', ' ')}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
